import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import { Paper, FormControl, TextField, InputLabel, MenuItem, Select, LinearProgress, Typography, IconButton, Fade } from '@material-ui/core';
import VariantSnackbar from '../share/VariantSnackbar';
import FilterBeneficiario from '../share/FilterBeneficiario';
import Utils from '../share/Utils';
import IntegrationAutosuggest from '../share/IntegrationAutosuggest';
import ProcessoService from '../../services/ProcessoService';
import { parse, format, isBefore } from 'date-fns';
import MUIDataTable from 'mui-datatables';
import TrashIcon from '@material-ui/icons/Delete';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import FormDialogProcedimentosCopartCalcIncorreto from './FormDialogProcedimentosCopartCalcIncorreto';
import AcertoCoparticipacaoService from '../../services/AcertoCoparticipacaoService';

const styles = theme => ({
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  body: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  formControlAutoCompleteBenef: {
    margin: theme.spacing.unit,
    minWidth: 400,
  },
  textFieldDtaEfeitoFinac: {
    marginBottom: theme.spacing.unit,
    marginLeft: theme.spacing.unit,
    width: 232,
    marginRight: theme.spacing.unit * 2,
  },
  selectAnoProcesso: {
    width: 180,
    marginTop: theme.spacing.unit * 0.5,
    marginBottom: theme.spacing.unit * 0.5,
  },
  textFieldNumProcesso: {
    width: 180,
    marginLeft: theme.spacing.unit,
    margin: theme.spacing.unit * -1.5,
  },
  formControlObservacao: {
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 4,
    width: 380,
  },
  divAdicionarPrestador: {
    textAlign: 'center'
  },
  buttonAdicionarPrestador: {
    margin: theme.spacing.unit,
  },
  fontTableRed: {
    fontSize: 13,
    color: 'red',
  },
  fontTableBlue: {
    fontSize: 13,
    color: 'blue',
  },
});
class FormDialogCopartCalculadaIncorreta extends React.Component {
  utils = new Utils();
  processoService = new ProcessoService();
  acertosService = new AcertoCoparticipacaoService();
  constructor (props) {
    super(props);
    this.state = {
      ...this.props.acerto,
      fetching: false,
      fetchingProcessos: false,
      nomesBeneficiarios: this.props.nomesBeneficiarios,
      processos: [],
      indCobrarDevolver: '',
      percentualSelected: 0,
      snackOpen: false,
      snackMessage: '',
      sucesso: false,
      errorMessageData: '',
      procedimentos: this.props.acerto.procedimentos === undefined ? [] : this.props.acerto.procedimentos,
      openDialog: false,
    };
    this.state.valAcerto = this.state.valAcerto === undefined ? '' : this.state.valAcerto.toString().indexOf('.') !== -1 ? this.state.valAcerto.toString() + '00' : this.state.valAcerto + '.00';
    this.state.valAcertoPrestador = this.state.valAcertoPrestador === undefined ? '' : this.state.valAcertoPrestador.toString().indexOf('.') !== -1 ? this.state.valAcertoPrestador.toString() + '00' : this.state.valAcertoPrestador + '.00';
    this.state.dtaEfeitoFinanc = format(parse(this.state.dtaEfeitoFinanc), 'YYYY-MM-DD');
  }

  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  };

  componentDidMount = async () => {
    this.setState({fetching: true});
    if (this.props.acerto.anoProcesso !== undefined && this.props.acerto.anoProcesso !== null) {
      await this.consultarProcessos(this.props.acerto.anoProcesso);
    }
    if (!this.props.modoInclusao) {
      let procedimentos = [];
      let procedimentosAux = await this.consultarProcedimentos(this.props.acerto.numProtocolo);
      procedimentosAux.map(res => {
        const { seqProcedimento, carteira, nome, codItem, desItem, tabela, seqBeneficiario, seqDependente, seqPrestador, desPrestador, codGuia, dtaProcedimento, indCopartCobradaTotal, percCoparticipacao, valProcedimento, valCoparticipacaoCalculada, valServidor, seqDivida, valAjusteProc } = res;
        let brancoAcoes = '';
        let novoValor = valAjusteProc + valServidor;
        procedimentos.push(Object.values({ seqProcedimento, carteira, nome, codItem, desItem, tabela, seqBeneficiario, seqDependente, seqPrestador, desPrestador, codGuia, dtaProcedimento, indCopartCobradaTotal, percCoparticipacao, valProcedimento, valCoparticipacaoCalculada, valServidor, seqDivida, novoValor, valAjusteProc, brancoAcoes }));
      });
      this.setState({procedimentos: procedimentos});
    }
    this.setState({fetching: false});
  }
  consultarProcedimentos = async (numProtocolo) => {
    this.setState({procedimentos: [], fetching: true});
    const procedimentos = await this.acertosService.consultarProcedimentos(numProtocolo);
    return procedimentos;
  }

  consultarProcessos = async (ano) => {
    let processos = await this.processoService.consultarProcessos(ano);
    this.setState({processos: processos});
  }

  handleClickLimpar = async () => {
    this.setState({
      numMatricula: '',
      nomeBeneficiario: '',
      procedimentos: [],
    });
  }

  handleSelectBeneficiario = (carteira, nome) => {
    if (nome !== this.state.nomeBeneficiario && carteira !== this.state.numMatricula) {
      this.setState({numMatricula: carteira, nomeBeneficiario: nome, procedimentos: [], valAcerto: 0});
    } else {
      this.setState({numMatricula: carteira, nomeBeneficiario: nome});
    }
  }

  handleBlurData = event => {
    if (this.state.dtaEfeitoFinanc === null ||
      this.state.dtaEfeitoFinanc === undefined ||
      this.state.dtaEfeitoFinanc === '') {
      this.setState({errorMessageData: 'Este campo é obrigatório'});
    } else {
      if (isBefore(parse(this.state.dtaEfeitoFinanc), parse(new Date().setHours(0, 0, 0, 0)))) {
        this.setState({errorMessageData: 'Data anterior a hoje'});
      } else {
        this.setState({errorMessageData: ''});
      }
    }
  }

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  handleChangeSelectAnoProcesso = async event => {
    this.setState({fetchingProcessos: true, numProcesso: ''});
    if (event.target.value !== 0) {
      let processos = await this.processoService.consultarProcessos(event.target.value);
      this.setState({ processos: processos });
    } else {
      await this.processoService.consultarAnosProcessos();
    }
    this.setState({anoProcesso: event.target.value, fetchingProcessos: false});
  }
  getSuggestionValueNumProcesso = (suggestion, id, a) => {
    if (suggestion.nome !== undefined) {
      this.setState({numProcesso: Number(suggestion.nome)});
    }
    if (suggestion === '' && id === 0) {
      this.setState({numProcesso: undefined});
    }
    return suggestion.nome;
  }
  handleChangeObservacao = event => {
    var novoValor = event.target.value;
    this.setState({ [event.target.name]: novoValor.toUpperCase() });
  };
  handleClickAdicionarProcedimentos = async () => {
    this.setState({openDialog: true});
  }
  handleCloseAdicionarProcedimentos = async () => {
    this.setState({openDialog: false});
  }
  handleSaveAdicionarProcedimentos = (procedimentos, valAcerto, indCobrarDevolver, percentualSelected) => {
    this.setState({fetching: true});
    let procedimentosAux = this.state.procedimentos;
    let valAcertoAux = Number(this.state.valAcerto);
    procedimentosAux = procedimentosAux.concat(procedimentos);
    procedimentosAux = procedimentosAux.sort(function (a, b) {
      if (a[0] === b[0]) return 0;
      return a[0] < b[0] ? -1 : 1;
    });
    this.setState({openDialog: false, procedimentos: procedimentosAux, valAcerto: Number(valAcertoAux + valAcerto), indCobrarDevolver: indCobrarDevolver, fetching: false, percentualSelected: percentualSelected});
  }

  isSalvarDisabled = () => {
    return (this.state.valAcerto === undefined ||
    this.state.valAcerto === 0 ||
    this.state.valAcerto === '000' ||
    this.state.valAcerto === '') ||

    (this.state.errorMessageData !== '' ||
     this.state.dtaEfeitoFinanc === undefined ||
     this.state.dtaEfeitoFinanc === 'Invalid Date' ||
     this.state.dtaEfeitoFinanc === '') ||

    (this.state.nomeBeneficiario === '' ||
     this.state.nomeBeneficiario === undefined) ||

     (
       ((this.state.anoProcesso !== undefined && this.state.anoProcesso !== 0) && (this.state.numProcesso === undefined || this.state.numProcesso === '' || this.state.numProcesso === 0)) ||
       ((this.state.anoProcesso === undefined || this.state.anoProcesso === 0 || this.state.anoProcesso === '') && (this.state.numProcesso !== undefined && this.state.numProcesso !== '' && this.state.numProcesso !== 0))
     );
  }

  handleClickSave = async () => {
    let procedimentos = [];
    for (var i = 0; i < this.state.procedimentos.length; i++) {
      let procedimento = {
        seqProcedimento: this.state.procedimentos[i][0],
        carteira: this.state.procedimentos[i][1],
        nome: this.state.procedimentos[i][2],
        codItem: this.state.procedimentos[i][3],
        desItem: this.state.procedimentos[i][4],
        codTabela: 0,
        desTabela: '',
        seqBeneficiario: this.state.procedimentos[i][6],
        seqDependente: this.state.procedimentos[i][7],
        seqPrestador: this.state.procedimentos[i][8],
        desPrestador: this.state.procedimentos[i][9],
        codGuia: this.state.procedimentos[i][10],
        dtaProcedimento: this.state.procedimentos[i][11],
        valProcedimento: 0,
        valServidor: this.state.procedimentos[i][14],
        valRestaPagar: 0,
        seqDivida: 0,
        valAjusteProc: this.state.procedimentos[i][19],
        novoPercentual: this.state.percentualSelected
      };
      procedimentos.push(procedimento);
    }
    const acerto = {
      numProtocolo: this.state.numProtocolo === undefined ? 0 : this.state.numProtocolo,
      seqBeneficiario: this.state.seqBeneficiario === undefined ? 0 : this.state.seqBeneficiario,
      seqDependente: this.state.seqDependente === undefined ? 0 : this.state.seqDependente,
      numMatricula: this.state.numMatricula,
      nomeBeneficiario: '',
      valAcerto: this.state.valAcerto,
      codTipo: this.state.codTipo === undefined ? 6 : this.state.codTipo,
      desTipo: '',
      codEstado: this.state.codEstado === undefined ? 1 : this.state.codEstado,
      desEstado: '',
      txtObservacao: this.state.txtObservacao === undefined ? '' : this.state.txtObservacao,
      dtaCadastro: null,
      dtaEfeitoFinanc: this.state.dtaEfeitoFinanc === undefined ? null : this.state.dtaEfeitoFinanc,
      numProcesso: this.state.numProcesso === undefined ? 0 : this.state.numProcesso,
      anoProcesso: this.state.anoProcesso === undefined ? 0 : this.state.anoProcesso,
      valAcertoPrestador: 0,
      seqPrestador: 0,
      indCancelado: 'N',
      codServidor: this.state.codServidor === undefined ? 0 : this.state.codServidor,
      historicos: [],
      procedimentos: procedimentos,
      seqDivida: this.state.procedimentos[0][13],
      numCnpjOrigemPagto: 0
    };
    await this.props.handleSave(acerto);
  }
  handleClickExcluirProcedimento = (event, tableMeta) => {
    let procedimentosAux = this.state.procedimentos.slice();
    procedimentosAux.splice(tableMeta.rowIndex, 1);
    let valAcertoAux = 0;
    for (var i = 0; i < procedimentosAux.length; i++) {
      valAcertoAux = valAcertoAux + Number(procedimentosAux[i][19]);
    }
    this.setState({ procedimentos: procedimentosAux, valAcerto: valAcertoAux });
  };
  render () {
    const options = {
      print: true,
      download: true,
      selectableRows: false,
      filterType: 'dropdown',
      rowsPerPageOptions: [5, 10, 15],
      rowsPerPage: 10,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline', fontFamily: 'Roboto'}}>procedimento(s) selecionado(s)</Typography>,
        },
      }
    };
    const columns = [
      {
        name: 'Cod. Cobrança',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Carteira',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Nome',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Código',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Descrição',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Tabela',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'seqBeneficiario',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'seqDependente',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'seqPrestador',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Prestador',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Guia',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Data do Procedimento',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return <Typography variant='overline'>{value !== null ? format(new Date(value), 'DD/MM/YYYY') : '-'}</Typography>;
          },
        }
      },
      {
        name: 'Está na franquia?',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Percentual Cobrado',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return <Typography variant='overline'>{value + '%'}</Typography>;
          },
        }
      },
      {
        name: 'Valor do Procedimento',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'Valor Calculado de Copart.',
        options: {
          display: 'excluded',
          filter: false,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'Valor Efetivamente Cobrado',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'seqDivida',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Valor que Deveria Ter Sido Cobrado',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'Valor do Ajuste',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return this.state.indCobrarDevolver === 'COBRAR'
              ? <Typography className={classes.fontTableRed}>{nf.format(value)}</Typography>
              : this.state.indCobrarDevolver === 'DEVOLVER'
                ? <Typography className={classes.fontTableBlue}>{nf.format(value)}</Typography>
                : <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
        }
      },
      {
        name: 'Excluir',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            return (
              <IconButton
                id={'menuButton'}
                className={classes.iconButton}
                disabled={!this.props.isEditavel}
                aria-label='More'
                aria-owns={open ? 'long-menu' : null}
                aria-haspopup='true'
                title={'Excluir procedimento da listas'}
                onClick={event => this.handleClickExcluirProcedimento(event, tableMeta)}
              >
                <TrashIcon fontSize='default' />
              </IconButton>
            );
          },
        }
      },
    ];
    const { procedimentos, fetching } = this.state;
    const { classes, open, handleClose, titulo } = this.props;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='lg'
          fullWidth
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>
            {titulo + ' - '}
            Valor Total: {new Intl.NumberFormat('pt-BR', {style: 'currency', fontWeight: 'bold', currency: 'BRL'}).format(this.state.valAcerto)}
          </DialogTitle>
          <DialogContent>
            <Paper className={classes.body} elevation={1}>
              <FormControl component='filedset' className={classes.formControlAutoCompleteBenef}>
                <FilterBeneficiario
                  beneficiarios={this.props.nomesBeneficiarios}
                  disabled={!this.props.isEditavel}
                  nomeInicial={this.state.nomeBeneficiario}
                  carteiraInicial={this.state.numMatricula}
                  handleSelectBeneficiario={this.handleSelectBeneficiario}
                  handleClickLimpar={this.handleClickLimpar} />
              </FormControl>
              <FormControl>
                <TextField
                  id='date'
                  disabled={!this.props.isEditavel}
                  error={this.state.errorMessageData !== ''}
                  label={this.state.errorMessageData !== '' ? this.state.errorMessageData : '* Data Efeito Finac.'}
                  type='date'
                  value={this.state.dtaEfeitoFinanc}
                  onChange={this.handleChange}
                  onBlur={this.handleBlurData}
                  inputProps={{
                    name: 'dtaEfeitoFinanc',
                  }}
                  className={classes.textFieldDtaEfeitoFinac}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>
              <FormControl>
                <InputLabel shrink htmlFor='tipo-simple' className={classes.selectAnoProcesso}>
                  Ano Processo
                </InputLabel>
                <Select
                  className={classes.selectAnoProcesso}
                  disabled={!this.props.isEditavel}
                  value={this.state.anoProcesso}
                  onChange={this.handleChangeSelectAnoProcesso}
                  inputProps={{
                    name: 'anoProcesso',
                  }}
                >
                  <MenuItem key={0} value={0}>{''}</MenuItem>
                  {this.props.anosProcessos.map((ano, idx) => {
                    return (<MenuItem key={idx + 1} value={ano}>{ano}</MenuItem>);
                  })}
                </Select>
              </FormControl>
              <FormControl className={classes.textFieldNumProcesso}>
                {this.state.fetchingProcessos ? <LinearProgress color='primary' />
                  : <IntegrationAutosuggest
                    disabled={this.state.anoProcesso === null || this.state.anoProcesso === undefined || this.state.anoProcesso === 0 || !this.props.isEditavel}
                    getSuggestionValue={this.getSuggestionValueNumProcesso}
                    suggestions={this.state.processos}
                    idSelected={this.state.anoProcesso === null || this.state.anoProcesso === undefined ? 0 : this.state.anoProcesso}
                    nomeSelected={this.state.numProcesso === null || this.state.numProcesso === undefined || this.state.numProcesso === 0 ? '' : this.state.numProcesso.toString()}
                    maxSuggestions={3}
                    label={'Número Processo'} />}
              </FormControl>
              <FormControl className={classes.formControlObservacao}>
                <TextField
                  value={this.state.txtObservacao === null ? '' : this.state.txtObservacao}
                  margin='dense'
                  disabled={!this.props.isEditavel}
                  id='txtObservacao'
                  name='txtObservacao'
                  label='Observação'
                  fullWidth
                  onChange={this.handleChangeObservacao}
                  multiline
                  style={{maxlength: '1000'}}
                  rowsMax='10'
                  helperText='(max. 1.000 caracteres)'
                />
              </FormControl>
            </Paper>
            <Paper>
              <div className={classes.divAdicionarPrestador}>
                <Button
                  disabled={(this.state.nomeBeneficiario === '' || this.state.nomeBeneficiario === undefined) || !this.props.isEditavel}
                  color='primary'
                  variant='contained'
                  className={classes.buttonAdicionarPrestador}
                  onClick={this.handleClickAdicionarProcedimentos}
                  id={'adicionarProcedimentos'}>
                  Adicionar Procedimentos
                </Button>
              </div>
              {fetching ? <LinearProgressBlockScreen />
                : <Fade timeout={1000} in>
                  <Paper className={classes.body} elevation={1}>
                    <MUIDataTable
                      data={procedimentos}
                      columns={columns}
                      options={options}
                    />
                  </Paper>
                </Fade>}
            </Paper>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              disabled={this.isSalvarDisabled() || !this.props.isEditavel}
              onClick={this.handleClickSave}
              color='primary'>
              Salvar
            </Button>
          </DialogActions>
        </Dialog>
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.sucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
        {this.state.openDialog &&
        <FormDialogProcedimentosCopartCalcIncorreto
          open={this.state.openDialog}
          handleClose={this.handleCloseAdicionarProcedimentos}
          handleSave={this.handleSaveAdicionarProcedimentos}
          titulo={'Adicionar Procedimentos com Cálculo de Coparticipação Incorreta'}
          procsSelecionados={this.state.procedimentos}
          nome={this.state.nomeBeneficiario}
          numMatricula={this.state.numMatricula} />}
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogCopartCalculadaIncorreta);
